import { Box, Stat, StatLabel, StatNumber } from '@chakra-ui/react';
import Game from '../../../classes/Game';
import { withGame } from '../helpers';

 function GameInfo({ game: g }: { game: Game}) {

  return <Box position="absolute" top={2} right={2} zIndex={1} minWidth={24} pointerEvents="none">
    <Stat>
    <StatLabel>Balance</StatLabel>
      <StatNumber>${g.getBalance().toFixed(2)}</StatNumber>
    </Stat>
    {/* <FormControl>
      <FormLabel htmlFor='level'>Level</FormLabel>
      <Select id='anim' onChange={e => {
        const val = parseInt(e.target.value)
        g.setLevel(val)
      }}>
        {g.levels.map((l, i) => <option key={i} value={i}>Level {i+1}</option>)}
      </Select>
    </FormControl> */}
  </Box>
}

export default withGame(GameInfo)